export default __webpack_public_path__ + "static/media/home-candle-white.2d0203b5.png";